import axios from 'axios';
import { AiReportCustomerProfile } from '../models/AiReportCustomerProfile';

const API_URL = process.env.REACT_APP_SERVER_URL + "/app/ai-report-customer-profiles";

const authHeader = () => ({
    Authorization: `Bearer ${localStorage.getItem('gpcwstoken_kw')}`,
});

export type AiReportCustomerProfileInput = Omit<AiReportCustomerProfile, 'id' | 'created_user_id' | 'created_time' | 'updated_time'>;

const aiReportCustomerProfileService = {
    getAll: async (): Promise<AiReportCustomerProfile[]> => {
        const response = await axios.get<AiReportCustomerProfile[]>(API_URL, { headers: authHeader() });
        return response.data;
    },

    getById: async (id: number): Promise<AiReportCustomerProfile> => {
        const response = await axios.get<AiReportCustomerProfile>(`${API_URL}/${id}`, { headers: authHeader() });
        return response.data;
    },

    create: async (data: AiReportCustomerProfileInput): Promise<AiReportCustomerProfile> => {
        const response = await axios.post<AiReportCustomerProfile>(`${API_URL}/add`, data, { headers: authHeader() });
        return response.data;
    },

    update: async (id: number, data: AiReportCustomerProfileInput): Promise<AiReportCustomerProfile> => {
        const response = await axios.put<AiReportCustomerProfile>(`${API_URL}/update/${id}`, data, { headers: authHeader() });
        return response.data;
    },

    remove: async (id: number): Promise<void> => {
        await axios.delete(`${API_URL}/delete/${id}`, { headers: authHeader() });
    },

    bulkImport: async (file: File): Promise<{ success: boolean; created: number; updated: number; skippedRows: number[]; totalRows: number }> => {
        const formData = new FormData();
        formData.append('file', file);
        const response = await axios.post(`${API_URL}/import`, formData, {
            headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    },
};

export default aiReportCustomerProfileService;
